/**
 * Vertical pages that get detail rows.
 *
 * The three rewrites are here because their copy was generic CRM language for
 * businesses the product serves specifically — /for/dental sold "visit history
 * and private notes" to practices that can chart per tooth surface.
 *
 * Their hero photos are NOT replaced. New imagery arrives in the detail rows,
 * which is why this registry exists rather than a change to the hero.
 */
export const RICH_VERTICALS = {
  // Rewritten
  dental:    { deepDive: 3 },
  clinics:   { deepDive: 3 },
  medspa:    { deepDive: 3 },
  // New
  laser:      { deepDive: 3 },
  aesthetic:  { deepDive: 3 },
  academies:  { deepDive: 3 },
  rentals:    { deepDive: 3 },
  physio:     { deepDive: 3 },
  nutrition:  { deepDive: 3 },
};
